import { Auth } from '@aws-amplify/auth';
import { CognitoUserSession } from 'amazon-cognito-identity-js';
import ky from 'ky';

import { getImpersonatedUserId } from '../containers/ImpersonationContainer';
import { SectorDataInstance } from '../providers/SectorDataProvider';

/**
 * Get the JWT from the current Amplify session if available.
 * @return The JWT string if there is an active session, otherwise undefined
 */
export async function getToken(): Promise<string | undefined> {
  try {
    const session: CognitoUserSession = await Auth.currentSession();
    return session.getIdToken().getJwtToken();
  } catch {
    return undefined;
  }
}

const httpClient = ky.create({
  hooks: {
    beforeRequest: [
      async (request) => {
        const token = await getToken();
        const impersonatedUserId = getImpersonatedUserId();
        const selectedSectorsIds = SectorDataInstance.getSelectedSectorsIds();

        if (token) {
          request.headers.set('Authorization', `Bearer ${token}`);
        }
        if (impersonatedUserId) {
          request.headers.set('X-Impersonate-User-ID', impersonatedUserId);
        }
        if (selectedSectorsIds.length > 0) {
          request.headers.set('X-Sser-Sectors', selectedSectorsIds.join(','));
        }
      },
    ],
  },
});

export default httpClient;
